import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddExpansionJointWizard.scss";
import autobind from "autobind-decorator";
import AddExpansionJointIcon from "../assets/images/add-expansion-joint-60x60.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createExpansionJoint, listExpansionJoints} from "../redux/actions/table/expansion_joints";
import AddExpansionJointForm from "../forms/add_expansion_joint_wizard/AddExpansionJointForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["expansion_joints"],
}))
class AddExpansionJointWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createExpansionJoint(this.props.match.params.stage, formData).then(({response}) => {
				listExpansionJoints(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('expansion_joints', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('expansion_joints', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-expansion-joint.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-expansion-joint.title.add-new-expansion-joint')}</span>
						<span>{__('wizard.add-expansion-joint.subtitle.add-new-expansion-joint')}</span>
					</div>
					<div className={styles.right}>
						<AddExpansionJointIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddExpansionJointForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddExpansionJointWizard;